import { getFormatLang } from './langs.utils.js';

const formatNumber = (number = 0, minimumFractionDigits, locale = getFormatLang()) => {
    return new Intl.NumberFormat(locale, {
        minimumFractionDigits,
    }).format(number);
};

export { formatNumber };
//# sourceMappingURL=formatNumber.utils.js.map
